<template>
    <div></div>
</template>

<script>
import meta_pixel from "./meta_pixel";
function safeEval(code) {
    return (new Function('return ' + code))();
}
export default {
    props: {
        answers: { type: Array },
        debug: { type: Boolean },
        sid: { type: String, required: true },
        meta: { type: Object, required: true },
        current: { type: Object, required: true },
        funnel: { type: Object, required: true },
        steps: { type: Array, required: true },
        loaded: { type: Boolean, required: true },
    },
    watch: {
        "current.index"(from, to) {
            console.log("Script: index changed: ", from, to);
            this.evalScripts();
        }
    },
    methods: {
        mountHeadCodeOnes() {
            console.log("Mount head codes", this.funnel);
            if (this.funnel.integrations && this.funnel.integrations.length > 0 ) {
                let integrations = this.funnel.integrations
                for(let idx in integrations) {
                    if (integrations[idx].type == "meta_pixel") {
                        let script = document.createElement('script');
                        script.type = 'text/javascript';
                        let code = meta_pixel.codes.init;
                        code = code.replace("%pixel_id%", integrations[idx].data.pixel_id)
                        script.innerHTML=code
                        document.head.appendChild(script);
                    }
                }
            }
        },
        evalScripts() {
            if (this.funnel.integrations && this.funnel.integrations.length > 0 ) {
                console.log("Eval integrations", this.funnel)
                let integrations = this.funnel.integrations
                for(let idx in integrations) {
                    if (integrations[idx].type == "meta_pixel") {
                        let code = meta_pixel.codes.step;
                        code = code.replace("%pixel_id%", integrations[idx].data.pixel_id)
                        /* eslint-disable no-eval */
                        safeEval(code);
                    }
                }
            }
            if (this.steps[this.current.index] && this.steps[this.current.index].tracking_head ) {
                let headSourceCode = this.steps[this.current.index].tracking_head
                var script = document.createElement("script");
                script.type="text/javascript";
                script.innerHTML=headSourceCode;
                document.getElementsByTagName('head')[0].appendChild(script);
            }
            // if (this.steps[this.current.index] && this.steps[this.current.index].integrations && this.steps[this.current.index].integrations.length > 0 ) {
            //     let integrations = this.steps[this.current.index].integrations
            //     for(let idx in integrations) {
            //         if (integrations[idx].type == "meta_pixel") {
            //             // let script = document.createElement('script');
            //             // script.type = 'text/javascript';
            //             let code = meta_pixel.codes.funnel;
            //             code.replace("%pixel_id%", integrations[idx].data.pixel_id)
            //             // script.innerHTML=code//integration.pivot.data.code;
            //             // document.head.appendChild(script);
            //             eval(code);
            //             console.log("Append meta");
            //         }
            //     }
            // }
            return false;
        },
    },
    mounted() {
        this.mountHeadCodeOnes();
        this.evalScripts(); // first init
    }
}
</script>

<style>

</style>
